import React, { useEffect, useRef, useCallback, useState } from "react";
//Import Scrollbar
import SimpleBar from "simplebar-react";
// import { subscribeToTokenRefresh } from "../../../../helpers/Refreshfile";
import { subscribeToTokenRefresh } from "../../helpers/Refreshfile";
// MetisMenu
import MetisMenu from "metismenujs";

import { Link } from "react-router-dom";
import classname from "classnames";
//i18n
import { withTranslation } from "react-i18next";
import withRouter from "../../Components/Common/withRouter";
import { useDomainContext } from 'pages/custom/DomainContext';



const SidebarContent = (props: any) => {


  const [cstPack, setCstPack] = useState(() => {
    const cstPackRaw = localStorage.getItem('cstpack');
    return cstPackRaw ? JSON.parse(cstPackRaw) : {};
  });
  // FREE_PLATFORM_MODE: Platform is free. To restore: localStorage.getItem('userole_') === "cst" && !cstPack?.active;
  const isInactiveCst = false;
  const { domains, setDomains, selectedSubdomain, setSelectedSubdomain, myParams, setMyParams, collapsed, setCollapsed } = useDomainContext();
  const [manage, management] = useState<boolean>(false);
  const [user, usermanagement] = useState<boolean>(false);

  const handleAccordionToggle = (did: any = null, iuser = false, imanage = false) => {
    const newCollapsed = {};
    domains.forEach(d => { newCollapsed[`domain_${d.id}`] = false; });
    if (did) { newCollapsed[`domain_${did}`] = !collapsed[`domain_${did}`]; }
    setCollapsed(newCollapsed);
    usermanagement((iuser) ? (!user) : false);
    management((imanage) ? (!manage) : false);
  }


  const ref = useRef<any>();
  const activateParentDropdown = useCallback((item: any) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
    let matchingMenuItem = null;
    const ul: any = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);

  useEffect(() => { ref.current.recalculate(); }, []);
  useEffect(() => { new MetisMenu("#side-menu"); }, []);

  // Listen for profile refresh events to update subscription status
  useEffect(() => {
    const handleRefreshProfile = () => {
      const cstPackRaw = localStorage.getItem('cstpack');
      if (cstPackRaw) {
        setCstPack(JSON.parse(cstPackRaw));
      }
    };
    window.addEventListener("refreshProfile", handleRefreshProfile);
    return () => {
      window.removeEventListener("refreshProfile", handleRefreshProfile);
    };
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
    subscribeToTokenRefresh(() => {
      console.log("🔁 Token refreshed. Re-fetching experts...");
      activeMenu();
    });
  }, [activeMenu]);

  function scrollElement(item: any) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }


  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>

        <div className="" id="sidebar-menu">
          <ul className="metismenu list-unstyled pt-4" id="side-menu">



            {false && isInactiveCst ? (null) : ( // FREE_PLATFORM_MODE: Always show menu. To restore: isInactiveCst ? (null) : (
              <>
                <li className="menu-title">{props.t("Business Services")}</li>
                {(domains && domains.length > 0) ? (
                  domains.map((domain) => (
                    (domain?.navroles?.includes(localStorage.getItem('userole_') || "") || localStorage.getItem('userole_') == "adm") ?
                      (
                        <li key={domain.id} className={`${collapsed[`domain_${domain.id}`] ? 'mm-active' : ''}`}>
                          <a onClick={() => { handleAccordionToggle(domain.id) }} className="has-arrow main-link domain-link">
                            <span className="domain-link-content">
                              <i className={`${domain?.iconclass || 'bx bx-crown'}`}></i>
                              <span className="text-capitalize domain-link-text">{props.t(domain.name)}</span>
                            </span>
                          </a>
                          {/* <ul className="sub-menu "> */}
                          <ul className={`sub-menu ${collapsed[`domain_${domain.id}`] ? '' : 'mm-collapse'}`}>
                            {domain?.navsubdomains?.map((subdomain) => (
                              (subdomain?.navroles?.includes(localStorage.getItem('userole_') || "") || localStorage.getItem('userole_') == "adm") ? (
                                <li key={subdomain.id}>
                                  <a className={`${(subdomain.id == selectedSubdomain?.id ? "text-secondary activeMenu text-capitalize" : 'text-capitalize')}`} style={{ cursor: "pointer" }} onClick={(e) => {
                                    e.preventDefault();
                                    const dIndex = domains.findIndex((d: any) => d.id === domain.id) + 1;
                                    const sIndex = domain.navsubdomains.findIndex((s: any) => s.id === subdomain.id) + 1;
                                    window.history.pushState({}, '', `/${dIndex}/${sIndex}`);
                                    setMyParams({ did: domain.id, sid: subdomain.id, rdomains: null });
                                  }}>
                                    {/* <span className="innerLinkMenu">{props.t(subdomain.name)} </span>  */}
                                    <span className={`innerLinkMenu ${subdomain.id == selectedSubdomain?.id ? 'fw-600' : ''}`}>
                                      {subdomain?.iconclass && (
                                        <i className={`${subdomain.iconclass} font-size-16 align-middle m-2`}></i>
                                      )}
                                      {subdomain?.name}
                                    </span>

                                  </a>
                                </li>
                              ) : null
                            ))}
                          </ul>
                        </li>
                      )
                      : (null)
                  ))
                ) : (<li className="text-muted text-center"><Link to="/" className="main-link"><span className="text-capitalize">No domains added yet.</span></Link></li>)}
                <li>
                  {(["prt", "emp"].includes(localStorage.getItem('userole_') || "")) ? null : (
                    <a className={`${((selectedSubdomain) ? "mb-0 normalMenu main-link" : "text-primary main-link")}`} id={`heading${0}`} style={{ cursor: "pointer" }} onClick={(e) => { e.preventDefault(); window.history.pushState({}, '', "/"); setMyParams({ did: 0, sid: 0, rdomains: null }); }} >
                      <i className="bx bx-user"></i>
                      <span>{props.t("All Experts")}</span>
                    </a>
                  )}
                </li>
                <li className="menu-title customDivider">{props.t("Account Center")}</li>
              </>
            )}



            {/* Admin menus here */}
            {localStorage.getItem("userole_") === "adm" && (
              <>
                {/* <li>
                  <Link to="/" className="main-link" onClick={() => {usermanagement(false); management(false);}}>
                    <i className="bx bx-home-circle me-2"></i>
                    {props.t("Home")}
                  </Link>
                </li> */}
                <li>
                  <Link to="/adashboard" className="main-link" onClick={() => { usermanagement(false); management(false); }}>
                    <i className="bx bx-bar-chart-square me-2"></i>
                    <span className="text-capitalize">{props.t("Dashboard")}</span>
                  </Link>
                </li>

                <li className={(manage) ? 'mm-active' : ''}>
                  <Link
                    className="has-arrow main-link"
                    onClick={e => {
                      e.preventDefault();
                      handleAccordionToggle(null, false, true)
                    }}
                    to="admincategories"
                  >
                    <i className="bx bx-food-menu me-2"></i>
                    <span className="text-capitalize">{props.t("Management")}{manage}</span>
                  </Link>
                  {/* <div className={classname("dropdown-menu", { show: manage })} > */}
                  <ul className={"sub-menu" + ((manage) ? ' ' : ' mm-collapse ')}>
                    <li>
                      <Link to="/admincategories" className="text-capitalize" onClick={() => management(false)} >
                        <span className="innerLinkMenu">
                          {props.t("Category Management")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/domains" className="text-capitalize" onClick={() => management(false)}>
                        <span className="innerLinkMenu">
                          {props.t("Domains Management")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/adminpacks" className="text-capitalize" onClick={() => management(false)}>
                        <span className="innerLinkMenu">
                          {props.t("Platform Packages")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/partnerplansubmissions" className="text-capitalize" onClick={() => management(false)}>
                        <span className="innerLinkMenu">
                          {props.t("Partner Plan Submissions")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/adminvalues" className="text-capitalize" onClick={() => management(false)}>
                        <span className="innerLinkMenu">
                          {props.t("Admin values")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/aorders" className="text-capitalize" onClick={() => management(false)}>
                        <span className="innerLinkMenu">
                          {props.t("All Orders")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/adminfeedback" className="text-capitalize" onClick={() => management(false)}>
                        <span className="innerLinkMenu">
                          {props.t("Customer Feedbacks")}</span>
                      </Link>
                    </li>
                  </ul>
                </li>


                <li className={(user) ? 'mm-active' : ''}>
                  <Link
                    className="has-arrow main-link"
                    onClick={e => {
                      e.preventDefault();
                      handleAccordionToggle(null, true, false)
                    }}
                    to="adminexperts"
                  >
                    <i className="bx bx-user-pin me-2"></i>
                    <span className="text-capitalize">{props.t("User Management")}</span>
                  </Link>
                  {/* <div className={classname("dropdown-menu", { show: user })} > */}
                  <ul className={"sub-menu " + ((user) ? ' ' : ' mm-collapse ')}>
                    <li>
                      <Link to="/adminexperts" className="dropdown-item" onClick={() => usermanagement(false)}>
                        <span className="innerLinkMenu">
                          {props.t("Experts Management")} </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/admincustomers" className="dropdown-item" onClick={() => usermanagement(false)}>
                        <span className="innerLinkMenu">
                          {props.t("Customers Management")} </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/admincompanies" className="dropdown-item" onClick={() => usermanagement(false)}>
                        <span className="innerLinkMenu">
                          {props.t("All Companies")} </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/abookings" className="dropdown-item" onClick={() => usermanagement(false)}>
                        <span className="innerLinkMenu">
                          {props.t("Customer Bookings")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/adminpartners" className="dropdown-item" onClick={() => usermanagement(false)}>
                        <span className="innerLinkMenu">
                          {props.t("Partner Management")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/adminemployees" className="dropdown-item" onClick={() => usermanagement(false)}>
                        <span className="innerLinkMenu">
                          {props.t("Employee Management")}</span>
                      </Link>
                    </li>
                  </ul>
                </li>


                <li>
                  <Link to="/adminAssignments" className="main-link" onClick={() => { usermanagement(false); management(false); }}>
                    <i className="bx bx-task me-2"></i>
                    <span className="text-capitalize">{props.t("Assignments")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/marketing" className="main-link" onClick={() => { usermanagement(false); management(false); }}>
                    <i className="bx bx-envelope me-2"></i>
                    <span className="text-capitalize">{props.t("Marketing")}</span>
                  </Link>
                </li>
              </>
            )}

            {/* Expert Menus here */}
            {localStorage.getItem("userole_") === "exp" && (
              <>
                <li>
                  <Link to="/edashboard" className="main-link">
                    <i className="bx bx-home-circle me-2"></i>
                    <span className="text-capitalize">{props.t("Dashboard")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/ebookings" className="main-link">
                    <i className="bx bx-calendar me-2"></i>
                    <span className="text-capitalize">{props.t("My Bookings")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/availability" className="main-link">
                    <i className="bx bx-calendar-event me-2"></i>
                    <span className="text-capitalize">{props.t("Availability")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/package" className="main-link">
                    <i className="bx bx-package me-2"></i>
                    <span className="text-capitalize">{props.t("My Packages")}</span>
                  </Link>
                </li>
              </>
            )}

            {/* Customer menus here */}
            {localStorage.getItem("userole_") === "cst" && (
              <>
                <li>
                  <Link to="/" className="main-link">
                    <i className="bx bx-home-circle me-2"></i>
                    <span className="text-capitalize">{props.t("Home")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/cdashboard" className="main-link">
                    <i className="bx bx-home-circle me-2"></i>
                    <span className="text-capitalize">{props.t("Dashboard")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/corders" className="main-link">
                    <i className="bx bx-user-check me-2"></i>
                    <span className="text-capitalize">{props.t("Orders & Purchases")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/cbookings" className="main-link">
                    <i className="bx bx-calendar-event me-2"></i>
                    <span className="text-capitalize">{props.t("My Bookings with Experts")}</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to="/billing-history" className="main-link">
                    <i className="bx bx-history me-2"></i>
                    <span className="text-capitalize">{props.t("Billing History")}</span>
                  </Link>
                </li> */}
                <li>
                  <Link to="/cfeedback" className="main-link">
                    <i className="bx bx-comment-dots me-2"></i>
                    <span className="text-capitalize">{props.t("Feedback")}</span>
                  </Link>
                </li>
                {/* <li>
                <Link to="/cprofile" className="main-link">
                  <i className="bx bx-user me-2"></i>
                  {props.t("Customer Profile")}
                </Link>
              </li> */}

              </>
            )}

            {/* Partner menus here */}
            {localStorage.getItem("userole_") === "prt" && (
              <>
                <li>
                  <Link to="/" className="main-link">
                    <i className="bx bx-home-circle me-2"></i>
                    <span className="text-capitalize">{props.t("Home")}</span>
                  </Link>
                </li>
              </>
            )}

            {/* Employee menus here */}
            {localStorage.getItem("userole_") === "emp" && (
              <>
                <li>
                  <Link to="/" className="main-link">
                    <i className="bx bx-home-circle me-2"></i>
                    <span className="text-capitalize">{props.t("Home")}</span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>

      </SimpleBar>
    </React.Fragment>
  );
};
export default withRouter(withTranslation()(SidebarContent));
